import React from "react";
import Image from "next/image";
import { DealersType } from "./DealerSidebar";
import DealerLeadButton from "./ui/Lead/DealerLeadButton";

const DealerCard = ({ dealer, allModels }: { dealer: DealersType, allModels: any[] }) => (
  <div className="rounded-[20px] border border-[#EAECF0] p-[13px] bg-white mb-4 last:mb-0">
    <div className="flex items-center gap-2 mb-3">
      <p className="text-[15px] font-bold text-[#17202A] truncate">
        {dealer.name}
      </p>
    </div>

    {/* Location Info with Tooltip */}
    <div className="relative group flex items-start gap-2 mb-3">
      <Image
        src={`${process.env.NEXT_PUBLIC_CDN_STATIC_URL}location-rad.svg`}
        alt="location"
        width={16}
        height={16}
        className="mt-1 shrink-0"
      />
      <p className="text-[12px] text-[#667085] line-clamp-2 cursor-help">
        {dealer.address}
      </p>

      {/* Tooltip Box */}
      <div className="invisible group-hover:visible absolute bottom-full left-0 mb-2 w-full z-[100] pointer-events-none">
        <div className="bg-[#344054] text-white text-[12px] leading-[18px] p-2 rounded-lg shadow-xl border border-gray-600">
          {dealer.address}
          <div className="absolute -bottom-1 left-4 w-2 h-2 bg-[#344054] rotate-45"></div>
        </div>
      </div>
    </div>

    <DealerLeadButton btnText="Get Best Offers" dealer_id={dealer.id} fullWidth models={allModels}  />
  </div>
);

export default DealerCard;
